import useLoadingIndicator from "../../../../component/Loader/Loader";
import MainCard from "../../../../component/MainCard/MainCard";
import ProjectDetailsTab from "../../../../component/ProjectDetailsTab/ProjectDetailsTab";
import { Strings } from "../../../../constant/Strings";
import ProfileTabs from "../../../../component/Tabs/Tabs";
import { useEffect, useState } from "react";
import PoHistory from "../../ProjectRepository/ProjectRepositoryFunctions/PoHistory";
import ScoreTab from "./ScoreTab";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as actions from "../../../../Redux/Actions";

const ResourcePOHistory = () => {
  const { resourceName } = Strings;
  const { id, projectId } = useParams();
  const dispatch = useDispatch();
  const [poHistoryData, setPoHistoryData] = useState([]);
  const [resourceNameVal, setResourceNameVal] = useState("");
  useEffect(() => {
    showLoadingIndicator();
    dispatch(
      actions.getResourcePODetailsAction(id, (res: any) => {
        if (res?.length > 0) {
          setPoHistoryData(res);
          setResourceNameVal(res?.[0]?.resourceName?.split("-")[0]);
        }
        hideLoadingIndicator();
      })
    );
  }, [id]);
  const {
    showLoadingIndicator,
    hideLoadingIndicator,
    loadingComponent,
  } = useLoadingIndicator();
  const [activeTab, setActiveTab] = useState<"poHistory" | "score">("poHistory");

  return (
    <>
      {loadingComponent()}
      <MainCard>
        <ProjectDetailsTab
          navigateTo={`/resource-adding/${projectId}`}
          tabHeading={resourceName}
          headingValue={resourceNameVal}
        />
        <div className="tabs-container">
          <ProfileTabs
            title="PO History"
            onClick={() => setActiveTab("poHistory")}
            active={activeTab === "poHistory"}
          />
          <ProfileTabs
            title="Score"
            onClick={() => setActiveTab("score")}
            active={activeTab === "score"}
          />
        </div>
        <div className="profile-container">
          {activeTab === "poHistory" && <PoHistory poHistoryData={poHistoryData} />}
          {activeTab === "score" && <ScoreTab resourceAllocationRef={id} resourceName={resourceNameVal} />}
        </div>
      </MainCard>
    </>
  );
};
export default ResourcePOHistory;
